import { i as g, x as d, s as b } from "../../../lit-element-6iugfgmM.js";
import { e as u } from "../../../custom-element-wk-AooBb.js";
import { n as h } from "../../../property-BWlAHqg_.js";
import "../../../query-assigned-elements-B8U94KLQ.js";
import "../../../sp-button-fa52iiKJ.js";
import "../../../sp-dialog-C9swJ4nV.js";
import "../../../sp-link-Bvw83YuP.js";
import { Localize as p } from "../../../lib/I18N.js";
const c = { "libraries-load-error-dialog.body": "Unable to load your libraries right now.", "libraries-load-error-dialog.button": "OK", "libraries-load-error-dialog.heading": "Error loading libraries", "libraries-load-error-dialog.quota-error-body": "You can't create new libraries or add more fonts to existing ones because your storage is full. {link}.", "libraries-load-error-dialog.quota-error-heading": "Your storage is full", "libraries-load-error-dialog.quota-error-link": "Learn how to manage cloud storage", "libraries-load-error-dialog.0gb-error-body": "Your account doesn't have access to cloud storage, which is required to create and use libraries.", "libraries-load-error-dialog.0gb-error-heading": "Storage not available" }, m = g`p{text-align:left;text-wrap:wrap}`;
var y = Object.defineProperty, f = Object.getOwnPropertyDescriptor, n = (o, e, a, i) => {
  for (var l, r = i > 1 ? void 0 : i ? f(e, a) : e, s = o.length - 1; s >= 0; s--) (l = o[s]) && (r = (i ? l(e, a, r) : l(r)) || r);
  return i && r && y(e, a, r), r;
};
let t = class extends p(b, c) {
  constructor() {
    super(...arguments), this.errorType = "";
  }
  static get styles() {
    return [m];
  }
  render() {
    return d`<sp-dialog size="m" variant="information"><h2 slot="heading">${this._getHeading()}</h2><p>${this._getBody()}</p><sp-button variant="primary" treatment="outline" slot="button" @click="${this._handleCloseButtonClick}">${this.t("libraries-load-error-dialog.button")}</sp-button></sp-dialog>`;
  }
  _handleCloseButtonClick() {
    this.dispatchEvent(new Event("close", { bubbles: !0, composed: !0 }));
  }
  _getBody() {
    if (this.errorType === "quota") {
      const o = d`<sp-link href="https://helpx.adobe.com/creative-cloud/kb/file-storage-quota.html" target="_blank">${this.t("libraries-load-error-dialog.quota-error-link")}</sp-link>`;
      return this.t("libraries-load-error-dialog.quota-error-body", { link: o });
    }
    return this.errorType === "0gb" ? this.t("libraries-load-error-dialog.0gb-error-body") : this.t("libraries-load-error-dialog.body");
  }
  _getHeading() {
    return this.errorType === "quota" ? this.t("libraries-load-error-dialog.quota-error-heading") : this.errorType === "0gb" ? this.t("libraries-load-error-dialog.0gb-error-heading") : this.t("libraries-load-error-dialog.heading");
  }
};
n([h({ type: String })], t.prototype, "errorType", 2), t = n([u("af-libraries-load-error-dialog")], t);
const B = t;
export {
  B as default
};
//# sourceMappingURL=LibrariesLoadErrorDialog.js.map
